(function(){
'use strict';

var CONFIG = {
  endUrl:   'https://try-myoro.co/pages/virex',

  skipUrl:  'https://try-myoro.co/pages/virex',

  logo:     'https://cdn.shopify.com/s/files/1/0748/1537/3390/files/image-removebg-preview_20.png?v=1787110925',

  endpoint: 'https://script.google.com/macros/s/AKfycbxazzVTa3MMMhyM2sed_-7KOWpJorP-owDfxsTnRQfqQhWhGtF0y8P5iO3cXMFcLBgh/exec',            // Web App URL của Apps Script. Rỗng = chỉ log console.
  token:    'quizfunnel',   // khớp SECRET trong Code.gs

  loadingMs: 3400,
  autoAdvanceMs: 260
};

var IMAGES = {
  'age-30-39'  : 'https://assets.prd.heyflow.com/flows/yoLrKqgUSeQJbSnfzo7s/www/assets/a09d4e5e-bc71-4fd9-8467-a70474466e49/large-icon.avif',
  'age-40-49'  : 'https://assets.prd.heyflow.com/flows/yoLrKqgUSeQJbSnfzo7s/www/assets/569bcbab-fde4-45bf-b3e6-35ea4232208d/large-icon.avif',
  'age-50-59'  : 'https://assets.prd.heyflow.com/flows/yoLrKqgUSeQJbSnfzo7s/www/assets/799fbb46-1e9a-4c21-b60c-b962ad0ddaf9/large-icon.avif',
  'age-60plus' : 'https://assets.prd.heyflow.com/flows/yoLrKqgUSeQJbSnfzo7s/www/assets/f5fb63a9-6417-4281-aa5d-18b6b785481f/large-icon.avif',
  'not-alone'  : 'https://cdn.shopify.com/s/files/1/0658/6377/8456/files/hf_20260630_072245_e9b27408-9a9d-44cb-bb5d-3149b7ba688d.png?width=355',
  'no-pain'    : 'https://myoro.co/cdn/shop/files/bcx-04.jpg?v=1785479807&width=600',
  'couple'     : 'https://cdn.shopify.com/s/files/1/0658/6377/8456/files/slot-04-v2.png?width=415',
  'doctor'     : 'https://cdn.shopify.com/s/files/1/0658/6377/8456/files/openart-image_1782462029318_c84ca964_1782462029633_5a613c46_af990e55-862a-4a86-8d1c-5e2e4c822a6d.png'
};

var STEPS = [
  { id:'age', type:'picture', counts:true, skip:true, legal:true,
    q:'How old are you?',
    sub:'This helps us calibrate your personalized recovery timeline.',
    opts:[
      {v:'30 - 39', img:'age-30-39'},
      {v:'40 - 49', img:'age-40-49'},
      {v:'50 - 59', img:'age-50-59'},
      {v:'60+',     img:'age-60plus'}
    ]
  },

  { id:'situation', type:'single', counts:true,
    q:'What best describes your current situation?',
    opts:[
      {v:'Trouble getting or keeping a firm erection', s:'Erections feel weaker or harder to maintain', w:3},
      {v:"Finish sooner than you'd like",              s:'Struggle to last as long as you want',        w:2},
      {v:'Want more size or fullness',                  s:'Looking to improve size and confidence',      w:1},
      {v:'Already functional, want peak performance',   s:'Boost stamina, strength, and control',        w:0},
      {v:'All of the above concerns',                   s:'Looking for a complete performance upgrade',  w:3}
    ]
  },

  { id:'duration', type:'single', counts:true,
    q:'How long have you been experiencing these challenges?',
    opts:[
      {v:'Less than 1 year', w:0},
      {v:'1 - 3 years',      w:1},
      {v:'3 - 5 years',      w:2},
      {v:'5+ years',         w:3}
    ]
  },

  { id:'impact', type:'single', counts:true,
    q:'How does this affect your confidence and relationship?',
    opts:[
      {v:'It causes me anxiety before intimacy.',    w:2},
      {v:'I avoid intimacy to avoid embarrassment.', w:3},
      {v:'My partner is frustrated/disappointed.',   w:3},
      {v:'It makes me feel "less of a man".',        w:2}
    ]
  },

  { id:'tried', type:'multi', counts:true, cta:'Continue',
    q:'What have you tried so far?',
    opts:[
      {v:'Prescription Pills (Viagra, Cialis, etc.)'},
      {v:'Supplements / Herbal remedies'},
      {v:'Pumps or Injections'},
      {v:'Nothing yet'}
    ]
  },

  { id:'expect', type:'multi', counts:true, cta:'Continue',
    q:'What result are you expecting from your treatment?',
    hint:"Choose as many as you'd like",
    opts:[
      {v:'Regain spontaneous erections (No planning pills).'},
      {v:'Stronger, harder erections naturally.'},
      {v:'Lasting longer in bed.'},
      {v:'Treating the root cause, not just masking symptoms.'},
      {v:'All of the above'}
    ]
  },

  { id:'social', type:'statement', img:'not-alone', cta:'Continue',
    eyebrow:'You are not alone',
    q:'50,000+ men started exactly here.',
    body:'Over 50,000 men in the US have chosen Virex\u2122 Pro to restore their vascular health and reclaim their confidence. 88% reported improved erection quality within 60 days.'
  },

  { id:'awareness', type:'single', counts:true,
    q:'Did you know that stress and poor circulation are the #1 hidden drivers of performance decline?',
    opts:[
      {v:"Yes, I've suspected that."},
      {v:'No, but that makes sense now.'}
    ]
  },

  { id:'consistency', type:'single', counts:true,
    q:'Virex\u2122 Pro requires consistency. Are you able to set aside 15 minutes, 3 times a week, in private?',
    opts:[
      {v:'Yes, I can find 15 mins.'},
      {v:'I have a busy schedule, but I can try.'}
    ]
  },

  { id:'painless', type:'statement', img:'no-pain', cta:'Sounds good',
    eyebrow:'No needles. No pills. No pain.',
    q:'It feels like a gentle tap.',
    body:'Many men worry that shockwave therapy hurts. It doesn\u2019t. Virex\u2122 Pro feels like a gentle tapping or vibration. It is 100% non-invasive and designed for home comfort.'
  },

  { id:'analyzing', type:'loading',
    msgs:[
      'Analyzing vascular profile',
      'Comparing with 50,000+ success stories',
      'Generating your growth plan'
    ]
  },

  { id:'score', type:'result',
    q:'Your Vascular Health Score',
    sub:'Based on your quiz responses',
    cta:'See my recovery plan'
  },

  { id:'roadmap', type:'roadmap',
    q:'Your 3-Month Recovery Roadmap',
    sub:'Based on your profile, here\u2019s what consistent Virex\u2122 Pro use can achieve:',
    miles:[
      {lbl:'Month 1', v:'Better sensitivity'},
      {lbl:'Month 2', v:'Firmer erections'},
      {lbl:'Month 3', v:'Performance restored'}
    ],
    note:'A 6-session-per-month protocol. Clinical-grade technology. Zero pills required.',
    cta:'Continue'
  },

  { id:'commit1', type:'single', counts:true,
    q:'Are you determined to finally stop relying on temporary "band-aid" pills?',
    opts:[{v:'Yes'}]
  },

  { id:'commit2', type:'single', counts:true, img:'couple',
    q:'Are you ready to treat the root cause using clinical-grade technology at home?',
    opts:[{v:'Yes'}],
    quote:'"My wife noticed the difference within the first month. I feel like myself again."',
    quoteBy:'Michael R., Age 54'
  },

  { id:'science', type:'statement', img:'doctor', cta:'Continue',
    eyebrow:'Backed by science',
    q:'Trusted by doctors.',
    body:'Virex\u2122 Pro uses clinically validated shockwave technology \u2014 the same approach trusted by urologists in over 50,000 treatments. Now available for private, at-home use with zero side effects.'
  },

  { id:'final', type:'final',
    q:'Virex\u2122 Pro comes with a 90-Day Money-Back Guarantee. Does a risk-free trial sound fair to you?',
    cta:'Yes, show me my plan'
  }
];

var KEY = 'vq_state_v2';
var root = document.getElementById('vq-root');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var state = load() || {
  sid: sid(), i:0, answers:{}, meta:meta(),
  startedAt: new Date().toISOString()
};
var countable = STEPS.filter(function(s){ return s.counts; }).length;

function sid(){
  return 'vq_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2,9);
}
function load(){ try{ return JSON.parse(sessionStorage.getItem(KEY)); }catch(e){ return null; } }
function save(){ try{ sessionStorage.setItem(KEY, JSON.stringify(state)); }catch(e){} }
function meta(){
  var p = new URLSearchParams(location.search);
  var m = {
    landing: location.href.split('#')[0],
    referrer: document.referrer || '',
    ua: navigator.userAgent,
    lang: navigator.language || '',
    screen: (window.screen && screen.width + 'x' + screen.height) || '',
    tz: (Intl.DateTimeFormat().resolvedOptions().timeZone) || ''
  };
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term',
   'fbclid','gclid','ttclid','msclkid'].forEach(function(k){ m[k] = p.get(k) || ''; });
  return m;
}

function track(event, extra){
  var payload = Object.assign({
    token: CONFIG.token, sid: state.sid, event: event,
    ts: new Date().toISOString(),
    step_index: state.i,
    step_id: (STEPS[state.i] && STEPS[state.i].id) || '',
    steps_total: STEPS.length,
    answers: state.answers, meta: state.meta
  }, extra || {});

  if (window.dataLayer) {
    window.dataLayer.push({
      event:'vq_' + event, vq_sid:state.sid,
      vq_step_id:payload.step_id, vq_step_index:state.i
    });
  }
  if (typeof window.fbq === 'function') {
    if (event === 'quiz_start')    window.fbq('trackCustom','QuizStart');
    if (event === 'quiz_complete') window.fbq('trackCustom','QuizComplete');
  }
  if (!CONFIG.endpoint) { console.log('[vq]', event, payload); return; }

  var body = JSON.stringify(payload);
  try{
    if (navigator.sendBeacon) {
      navigator.sendBeacon(CONFIG.endpoint, new Blob([body], {type:'text/plain;charset=UTF-8'}));
    } else {
      fetch(CONFIG.endpoint, {
        method:'POST', mode:'no-cors', keepalive:true,
        headers:{'Content-Type':'text/plain;charset=UTF-8'}, body:body
      });
    }
  }catch(e){}
}

function score(){
  var w = 0;
  ['situation','duration','impact'].forEach(function(k){
    var a = state.answers[k];
    if (a && typeof a.w === 'number') w += a.w;
  });
  var s = 5 - Math.round(w / 9 * 4);
  return Math.max(2, Math.min(3, s));   // ← clamp, sửa ở đây nếu muốn full 1..5
}
var SCORE_LABEL = {1:'Critical',2:'Compromised',3:'Below optimal',4:'Good',5:'Optimal'};
var SEG_COLOR   = ['#d94b3d','#e0762c','#c9a127','#4aa06a','#1f8a5f'];

function esc(s){
  return String(s).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  });
}
function img(key){
  var url = IMAGES[key];
  return url
    ? '<img src="'+esc(url)+'" alt="" loading="lazy" decoding="async">'
    : '<div class="vq__ph"><i>IMG<br>'+esc(key)+'</i></div>';
}
var ICON = {
  arrow:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M13 6l6 6-6 6"/></svg>',
  back:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
  check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.6l5.2 5.2L20 6.8"/></svg>',
  stetho:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3v6a5 5 0 0 0 10 0V3"/><circle cx="19" cy="15" r="2.5"/><path d="M10 14v2a6.5 6.5 0 0 0 6.6 6.4"/></svg>',
  heart:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 8.6a5 5 0 0 0-8.8-3 5 5 0 0 0-8.8 3c0 5.4 8.8 10.9 8.8 10.9s8.8-5.5 8.8-10.9z"/></svg>',
  drop:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.6 6 11a6 6 0 0 1-12 0c0-4.4 6-11 6-11z"/></svg>',
  up:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 17l6-6 4 4 6-7"/><path d="M20 4h-4M20 4v4"/></svg>',
  plan:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>'
};

function render(){
  var st = STEPS[state.i];
  var done = STEPS.slice(0,state.i).filter(function(s){ return s.counts; }).length;
  var pct  = Math.round(state.i / (STEPS.length - 1) * 100);

  var head =
    '<div class="vq__head">' +
      '<div class="vq__headRow">' +
        '<button class="vq__back" type="button" data-back aria-label="Go back"' +
          (state.i === 0 ? ' hidden' : '') + '>' + ICON.back + '</button>' +
        '<img class="vq__logo" src="' + esc(CONFIG.logo) + '" alt="Myoro" ' +
             'width="500" height="181" decoding="async">' +
        '<span class="vq__count">' +
          (st.counts ? String(done+1).padStart(2,'0') + '/' + String(countable).padStart(2,'0') : '') +
        '</span>' +
      '</div>' +
      '<div class="vq__track"><div class="vq__fill" style="width:'+pct+'%"></div></div>' +
      (st.skip
        ? '<div class="vq__skipWrap">' +
            '<a class="vq__skip" href="'+esc(CONFIG.skipUrl)+'" data-skip>' +
              ICON.stetho + '<span>Skip to doctor recommendation</span>' +
            '</a>' +
          '</div>'
        : '') +
    '</div>';

  root.innerHTML = head + '<div class="vq__stage">' + view(st) + '</div>';
  bind(st);

  // về đầu trang khi sang bước mới (không dùng smooth để không "trôi")
  try{ window.scrollTo(0,0); }catch(e){}

  if (st.type === 'loading') runLoading(st);
  if (st.type === 'result')  animResult();
  save();
}

function header(st){
  return (st.eyebrow ? '<span class="vq__eyebrow">'+esc(st.eyebrow)+'</span>' : '') +
         '<h1 class="vq__q">'+esc(st.q)+'</h1>' +
         (st.sub  ? '<p class="vq__sub">'+esc(st.sub)+'</p>'   : '') +
         (st.hint ? '<span class="vq__hint">'+esc(st.hint)+'</span>' : '');
}
function ctaBtn(label, attr){
  return '<button class="vq__cta" type="button" '+attr+'>' +
           '<span>'+esc(label)+'</span>'+ICON.arrow +
         '</button>';
}

function view(st){
  var h = '<div class="vq__step">';

  if (st.type === 'picture') {
    h += header(st);
    h += '<div class="vq__grid" role="radiogroup" aria-label="'+esc(st.q)+'">';
    st.opts.forEach(function(o,k){
      h += '<button class="vq__pic" type="button" role="radio" aria-checked="false" data-pick="'+k+'">' +
             '<span class="vq__picImg">'+img(o.img)+'</span><b>'+esc(o.v)+'</b></button>';
    });
    h += '</div>';
    if (st.legal) {
      h += '<p class="vq__legal">By choosing an option above you agree to the ' +
           '<a href="/policies/terms-of-service">Terms of Service</a> and ' +
           '<a href="/policies/privacy-policy">Privacy Policy</a>.</p>';
    }
  }

  else if (st.type === 'single') {
    h += header(st);
    h += '<div class="vq__opts" role="radiogroup" aria-label="'+esc(st.q)+'">';
    st.opts.forEach(function(o,k){
      h += '<button class="vq__opt" type="button" role="radio" aria-checked="false" data-pick="'+k+'">' +
             '<span class="vq__optTxt"><b>'+esc(o.v)+'</b>' +
             (o.s ? '<span>'+esc(o.s)+'</span>' : '') + '</span>' +
             '<span class="vq__mark vq__mark--radio">'+ICON.check+'</span></button>';
    });
    h += '</div>';
    if (st.quote) {
      h += '<p class="vq__quote">'+esc(st.quote)+' <b>&mdash; '+esc(st.quoteBy)+'</b></p>';
    }
    if (st.img) h += '<div class="vq__figure" style="margin-top:10px">'+img(st.img)+'</div>';
  }

  else if (st.type === 'multi') {
    h += header(st);
    h += '<div class="vq__opts" role="group" aria-label="'+esc(st.q)+'">';
    st.opts.forEach(function(o,k){
      h += '<button class="vq__opt" type="button" role="checkbox" aria-checked="false" data-toggle="'+k+'">' +
             '<span class="vq__optTxt"><b>'+esc(o.v)+'</b></span>' +
             '<span class="vq__mark vq__mark--box">'+ICON.check+'</span></button>';
    });
    h += '</div><div class="vq__foot">' + ctaBtn(st.cta,'data-next disabled') + '</div>';
  }

  else if (st.type === 'statement') {
    h += header(st);
    h += '<p class="vq__body">'+esc(st.body)+'</p>';
    h += '<div class="vq__figure">'+img(st.img)+'</div>';
    h += '<div class="vq__foot">' + ctaBtn(st.cta,'data-next') + '</div>';
  }

  else if (st.type === 'loading') {
    h += '<div class="vq__load">' +
           '<svg class="vq__ring" viewBox="0 0 100 100" aria-hidden="true">' +
             '<circle class="vq__ringBg" cx="50" cy="50" r="44"/>' +
             '<circle class="vq__ringFg" cx="50" cy="50" r="44" ' +
               'stroke-dasharray="276.5" stroke-dashoffset="276.5"/></svg>' +
           '<p class="vq__pct" data-pct>0%</p>' +
           '<p class="vq__loadTxt" data-loadtxt>'+esc(st.msgs[0])+'</p></div>';
  }

  else if (st.type === 'result') {
    var s = score(), lbl = SCORE_LABEL[s];
    state.answers._score = s;
    state.answers._score_label = lbl;

    h += header(st);
    h += '<div class="vq__card">';

    h += '<div class="vq__scoreTop">' +
           '<span class="vq__scoreNum" data-score-to="'+s+'">0<small>/5</small></span>' +
           '<span class="vq__chip">'+esc(lbl)+'</span>' +
         '</div>';

    h += '<div class="vq__seg" role="img" aria-label="Score '+s+' of 5: '+esc(lbl)+'">';
    for (var n=1; n<=5; n++){
      h += '<span class="vq__segCell" style="' +
             (n<=s ? 'background:'+SEG_COLOR[n-1]+';' : '') +
             'animation-delay:'+(0.06*n)+'s"></span>';
    }
    h += '</div><div class="vq__segEnds"><span>Critical</span><span>Optimal</span></div>';

    h += '<div class="vq__cells">' +
      cell('heart','#d94b3d','Erectile health', lbl, 0) +
      cell('drop','#d08a1e','Root cause','Restricted blood flow', 1) +
      cell('up','#1f8a5f','Recovery odds','High', 2) +
      cell('plan','#3560c2','Protocol','3-Month Rebuild', 3) +
    '</div>';

    h += '<div class="vq__stat">' +
           '<span class="vq__statBig" data-count-to="88">0%</span>' +
           '<span class="vq__statTxt">of men with your profile reported ' +
             '<b>improved erection quality within 60 days</b>.</span></div>';

    h += '<p class="vq__disc">An indicative summary of your answers, not a medical ' +
         'diagnosis. Speak to a doctor about ongoing symptoms.</p>';
    h += '</div>';
    h += '<div class="vq__foot">' + ctaBtn(st.cta,'data-next') + '</div>';
  }

  else if (st.type === 'roadmap') {
    h += header(st);
    h += chart();
    h += '<div class="vq__miles">';
    st.miles.forEach(function(m,k){
      h += '<div class="vq__mile" style="animation-delay:'+(0.85 + k*0.1)+'s">' +
             '<span class="vq__mileLbl">'+esc(m.lbl)+'</span>' +
             '<span class="vq__mileVal">'+esc(m.v)+'</span></div>';
    });
    h += '</div>';
    h += '<p class="vq__body" style="margin-top:11px">'+esc(st.note)+'</p>';
    h += '<div class="vq__foot">' + ctaBtn(st.cta,'data-next') + '</div>';
  }

  else if (st.type === 'final') {
    h += header(st);
    h += '<div class="vq__foot">' + ctaBtn(st.cta,'data-finish') +
         '<p class="vq__legal">90-day money-back guarantee &middot; ' +
         'Discreet, unbranded shipping</p></div>';
  }

  return h + '</div>';
}

function cell(ico, color, lbl, val, k){
  return '<div class="vq__cell" style="animation-delay:'+(0.3 + k*0.07)+'s">' +
           '<span class="vq__cellLbl" style="color:'+color+'">'+ICON[ico]+
             '<span style="color:var(--ink-3)">'+esc(lbl)+'</span></span>' +
           '<span class="vq__cellVal" style="color:'+color+'">'+esc(val)+'</span>' +
         '</div>';
}

function chart(){
  var pts = [[10,58],[75,36],[140,12]];   // viewBox 150×72
  var line = 'M'+pts[0][0]+' '+pts[0][1] +
             ' C 40 56, 48 42, '+pts[1][0]+' '+pts[1][1] +
             ' C 102 30, 112 18, '+pts[2][0]+' '+pts[2][1];
  var area = line + ' L140 66 L10 66 Z';

  var h = '<svg class="vq__chart" viewBox="0 0 150 72" ' +
            'preserveAspectRatio="none" style="height:clamp(88px,17dvh,132px)" ' +
            'role="img" aria-label="Projected improvement over three months">' +
    '<defs><linearGradient id="vqGrad" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#c0502c" stop-opacity=".26"/>' +
      '<stop offset="100%" stop-color="#c0502c" stop-opacity="0"/>' +
    '</linearGradient></defs>' +
    '<line class="vq__chartGrid" x1="10" y1="66" x2="140" y2="66"/>' +
    '<path class="vq__chartArea" d="'+area+'"/>' +
    '<path class="vq__chartLine" d="'+line+'"/>';

  pts.forEach(function(p,k){
    h += '<g class="vq__chartDot" style="animation-delay:'+(0.35 + k*0.22)+'s;' +
           'transform-origin:'+p[0]+'px '+p[1]+'px">' +
           '<circle cx="'+p[0]+'" cy="'+p[1]+'" r="5.4" fill="#fffdfa" ' +
             'stroke="#c0502c" stroke-width="2.2"/>' +
         '</g>';
  });
  return h + '</svg>';
}

function countUp(el, to, suffix, ms){
  if (reduce) { el.textContent = to + (suffix||''); return; }
  var t0 = null;
  function step(t){
    if (!t0) t0 = t;
    var p = Math.min(1, (t - t0) / ms);
    var e = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(to * e) + (suffix||'');
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
function animResult(){
  var sc = root.querySelector('[data-score-to]');
  if (sc) {
    var to = +sc.getAttribute('data-score-to');
    if (reduce) sc.innerHTML = to + '<small>/5</small>';
    else {
      var t0 = null;
      requestAnimationFrame(function step(t){
        if (!t0) t0 = t;
        var p = Math.min(1,(t-t0)/700);
        sc.innerHTML = Math.max(0, Math.round(to*p)) + '<small>/5</small>';
        if (p<1) requestAnimationFrame(step);
      });
    }
  }
  var st = root.querySelector('[data-count-to]');
  if (st) setTimeout(function(){ countUp(st, 88, '%', 900); }, 500);
}

function bind(st){
  var back = root.querySelector('[data-back]');
  if (back) back.addEventListener('click', function(){
    if (state.i > 0){ state.i--; render(); track('step_back'); }
  });

  var skip = root.querySelector('[data-skip]');
  if (skip) skip.addEventListener('click', function(){ track('quiz_skip'); });

  root.querySelectorAll('[data-pick]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var k = +btn.getAttribute('data-pick'), o = st.opts[k];
      root.querySelectorAll('[data-pick]').forEach(function(b){
        b.setAttribute('aria-checked','false');
      });
      btn.setAttribute('aria-checked','true');
      btn.classList.add('is-commit');
      state.answers[st.id] = { v:o.v, w:(typeof o.w==='number'?o.w:null) };
      save();
      track('answer', { answer:o.v });
      setTimeout(next, CONFIG.autoAdvanceMs);
    });
  });

  var cta = root.querySelector('[data-next]');
  root.querySelectorAll('[data-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var on = btn.getAttribute('aria-checked') === 'true';
      btn.setAttribute('aria-checked', on ? 'false' : 'true');
      var picked = [].slice.call(root.querySelectorAll('[data-toggle][aria-checked="true"]'))
        .map(function(b){ return st.opts[+b.getAttribute('data-toggle')].v; });
      state.answers[st.id] = { v:picked };
      save();
      if (cta) cta.disabled = picked.length === 0;
    });
  });
  if (cta) cta.addEventListener('click', function(){
    if (state.answers[st.id]) track('answer', { answer: state.answers[st.id].v });
    next();
  });

  var fin = root.querySelector('[data-finish]');
  if (fin) fin.addEventListener('click', function(){
    fin.disabled = true;
    state.answers[st.id] = { v:'Yes' };
    save();
    track('quiz_complete', { completed:true });
    setTimeout(function(){ location.href = outUrl(); }, 220);
  });

  document.addEventListener('keydown', keys);
}
function keys(e){
  if (e.metaKey || e.ctrlKey || e.altKey) return;
  var n = parseInt(e.key,10);
  if (!n) return;
  var list = root.querySelectorAll('[data-pick],[data-toggle]');
  if (list[n-1]) { e.preventDefault(); list[n-1].click(); }
}

function next(){
  document.removeEventListener('keydown', keys);
  if (state.i < STEPS.length - 1) { state.i++; render(); track('step_view'); }
}
function outUrl(){
  var u = new URL(CONFIG.endUrl);
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term',
   'fbclid','gclid','ttclid','msclkid'].forEach(function(k){
    if (state.meta[k]) u.searchParams.set(k, state.meta[k]);
  });
  u.searchParams.set('qz', state.sid);
  if (state.answers._score) u.searchParams.set('score', state.answers._score);
  return u.toString();
}

function runLoading(st){
  var ring  = root.querySelector('.vq__ringFg');
  var pctEl = root.querySelector('[data-pct]');
  var txtEl = root.querySelector('[data-loadtxt]');
  var C = 276.5, t0 = Date.now(), mi = -1;

  (function tick(){
    var p = Math.min(1,(Date.now()-t0)/CONFIG.loadingMs);
    if (ring)  ring.style.strokeDashoffset = String(C*(1-p));
    if (pctEl) pctEl.textContent = Math.round(p*100) + '%';
    var k = Math.min(st.msgs.length-1, Math.floor(p*st.msgs.length));
    if (k !== mi && txtEl) { mi = k; txtEl.textContent = st.msgs[k]; }
    if (p < 1) requestAnimationFrame(tick);
    else setTimeout(next, 260);
  })();
}

render();
track(state.i === 0 ? 'quiz_start' : 'quiz_resume');

})();
